var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.displayFilter
    ? _c(
        "div",
        [
          _c("input-debounced", {
            staticClass: "w-100",
            attrs: {
              value: _vm.value,
              clearable: _vm.clearable,
              placeholder: _vm.placeholders,
            },
            on: { input: _vm.onChange },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }